import Vue from 'vue';

import FormatTime from './FormatTime'

let filters = {
    FormatTime
}


for (let k in filters) {
    Vue.filter(k, filters[k])
}